import React from 'react';
import styled from 'styled-components';

import {
  VendorPhysicianNumberOutput,
} from '../../../../service-proxies';

import {
  Select,
  Field,
} from '../../../../components';

import * as miscellaneousApi from '../../../../_api/miscellaneous';

interface IRowError {
  vendor?: string;
  physicianName?: string;
  accountNumber?: string;
  addressNotes?: string;
}

interface IVendorPhysicianListProps {
  className: string;
  value: VendorPhysicianNumberOutput;
  index: number;
  error?: IRowError | undefined;
  onVendorChange: (text: string, index: number) => void;
  onNameChange: (text: string, index: number) => void;
  onNumberChange: (text: string, index: number) => void;
  onAddressNotesChange: (text: string, index: number) => void;
  onBlur: (e: any) => any;
}

export default styled(class extends React.PureComponent<IVendorPhysicianListProps> {
  constructor(props) {
    super(props);

    this.handleVendorChange = this.handleVendorChange.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleNumberChange = this.handleNumberChange.bind(this);
    this.handleAddressNotesChange = this.handleAddressNotesChange?.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.loadVendors = this.loadVendors.bind(this);
  }

  handleVendorChange(text) {
    this.props.onVendorChange(text, this.props.index);
  }

  handleNameChange(e) {
    const value = e.target.value;
    this.props.onNameChange(value, this.props.index);
  }

  handleNumberChange(e) {
    const value = e.target.value;
    this.props.onNumberChange(value, this.props.index);
  }

  handleAddressNotesChange(e) {
    const value = e.target.value;
    this.props.onAddressNotesChange(value, this.props.index);
  }

  handleBlur(e){
    this.props.onBlur(e);
  }

  loadVendors(text, callback) {
    miscellaneousApi.searchVendors('Allergan')
      .then(data => {
        const options = data.items;
        callback(null, {
          options,
          complete: true,
        });
      });
  }

  render() {
    const {
      className,
      value,
      index,
      error
    } = this.props;

    const rowError   = typeof error === 'object' ? (error as IRowError) : undefined;
    const vendorError = rowError?.vendor || undefined;
    const physicianNameError = rowError?.physicianName || undefined;
    const accountNumberError = rowError?.accountNumber || undefined;
    const physicianAddressNotesError = rowError?.addressNotes || undefined;

    return (
      <div className={className}>
        <Select
          compact
          async
          loadOnFocus
          autoload={false}
          name={`vendorPhysicianNumbers[${index}]`}
          labelKey="displayValue"
          valueKey="id"
          onChange={this.handleVendorChange}
          value={value.vendor}
          loadOptions={this.loadVendors}
          error={vendorError}
          onBlur={this.props.onBlur}
          className="vendor-select"
          />
          {
            !!value.vendor && 
            value.vendor.id && 
            (
            <div className="physician-list-container">
              <Field 
                compact
                placeholder="Physician Name" 
                name={`vendorPhysicianNumbers[${index}].physicianName`} 
                value={value.physicianName || ''}
                onChange={this.handleNameChange}
                onBlur={this.handleBlur}
                error={physicianNameError}
              />

              <Field 
                compact
                placeholder="Account Number" 
                name={`vendorPhysicianNumbers[${index}].accountNumber`} 
                value={value.accountNumber || ''}
                onChange={this.handleNumberChange}
                onBlur={this.handleBlur}
                error={accountNumberError}
              />

              <Field 
                compact
                placeholder="Address Notes" 
                name={`vendorPhysicianNumbers[${index}].addressNotes`} 
                value={value.addressNotes || ''}
                onChange={this.handleAddressNotesChange}
                onBlur={this.handleBlur}
                error={physicianAddressNotesError}
                />
            </div>
          )}
      </div>
    );
  }
})`
display: flex;
gap: 10px;
align-items: flex-start;
flex-wrap: nowrap;

.vendor-select {
  flex: 1 1 0;
  min-width: 0;
  width: 100%;
}

.physician-list-container {
  display: flex;
  flex: 3 1 0;
  gap: 10px;
  width: 100%;
}

  ${Select}{
    flex: 0 0 158px;
    margin: 0 10px 0 0;
  }

  ${Field} {
    padding: 0;
  }
`;